import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: false,
  user: null,
  loginToken: null,
};

export const userSlice = createSlice({
  name: "user", // Fix: Changed name from 'counter' to 'user'
  initialState,
  reducers: {
    setUser: (state, action) => {
      // Fix: Correctly destructure action.payload
      const { loggedIn, useraccount, token } = action.payload;

      console.log("Before Update:", JSON.parse(JSON.stringify(state))); // Deep copy for logging
      console.log("Action Payload:", action.payload);

      state.isLoggedIn = loggedIn;
      state.user = useraccount;
      state.loginToken = token;

      console.log("After Update:", JSON.parse(JSON.stringify(state))); // Deep copy for logging

      if (loggedIn) {
        localStorage.setItem("user", JSON.stringify(useraccount));
        localStorage.setItem("token", token);
      } else {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        state.user = null; // Fix: Clear user data when logged out
        state.loginToken = null;
      }
    },
    setUserAccount: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const { setUser, setUserAccount } = userSlice.actions;
export default userSlice.reducer;
